<!--
  @description
  Renders a list item (`<li>`) that contains a link with:
  - An icon (via the IconRegistry component, determined by the `icon` prop)
  - Text (via the `text` prop)
  - An optional caret style (via the `hasCaret` prop)
  - Conditional visibility (via the `show` prop)

  Example usage:
  <HelpAction
    :icon="action.icon"
    :text="action.text"
    :href="action.href"
    :hasCaret="hasCaret"
    :show="action.show"
  />
-->

<template>
  <li v-if="show && icon">
    <a
      v-bind="$attrs"
      class="button link no-bg help__action"
      :class="{ 'with-black-caret': hasCaret }"
      :href="href"
      target="_blank"
    >
      <IconRegistry :name="icon" class="help__action__icon" />
      <span>{{ text }}</span>
    </a>
  </li>
</template>

<script>
import IconRegistry from '../../Shared/Icons/IconRegistry.vue'

export default {
  components: {
    IconRegistry
  },
  props: {
    icon: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    href: {
      type: String,
      required: false
    },
    hasCaret: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default: true
    }
  }
}
</script>
<style lang="scss" scoped>
li{
	list-style: none;
}
.help__action {
  padding: 0;
  font-size: var(--font-normal);
  font-weight: var(--font-weight-lighter);
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  color: var(--black);

  &__icon {
    height: 20px;
    margin-right: 5px;
    fill: var(--black);
  }

  svg {
    margin-right: 15px;
  }
}
</style>
